//============================================================

// -- map

//============================================================

var map = {
  init: function () {
    var map01 = {
        lat: "35.682639",
        lng: "139.772585",
      },
      map02 = {
        lat: "35.1760341",
        lng: "136.8960908",
      },
      map03 = {
        lat: "34.734532",
        lng: "135.493019",
      };
    var latlng, map;

    for (var i = 0; i < 4; i++) {
      switch (i) {
        case 0:
          latlng = new google.maps.LatLng(map01.lat, map01.lng);
          break;
        case 1:
          latlng = new google.maps.LatLng(map02.lat, map02.lng);
          break;
        case 2:
          latlng = new google.maps.LatLng(map03.lat, map03.lng);
          break;
      }
      var myOptions = {
        zoom: 17 /*拡大比率*/,
        center: latlng /*表示枠内の中心点*/,
      };
      switch (i) {
        case 0:
          map = new google.maps.Map(
            document.getElementById("map_canvas"),
            myOptions
          );
          break;
        case 1:
          map = new google.maps.Map(
            document.getElementById("map_canvas2"),
            myOptions
          );
          break;
        case 2:
          map = new google.maps.Map(
            document.getElementById("map_canvas3"),
            myOptions
          );
          break;
      }
      var winW = $(window).width();
      if (winW <= 750) {
        /*アイコン設定▼*/
        var icon = new google.maps.MarkerImage(
          "../../corp_assets/img/company/outline/map_icon_sp.png",
          new google.maps.Size(75, 34) /*アイコンサイズ設定*/,
          new google.maps.Point(0, 0) /*アイコン位置設定*/
        );
        var markerOptions = {
          position: latlng,
          map: map,
          icon: icon,
          title: "株式会社アルペン",
        };
        var marker = new google.maps.Marker(
          markerOptions
        ); /*アイコン設定ここまで▲*/
      } else {
        /*アイコン設定▼*/
        var icon = new google.maps.MarkerImage(
          "../../corp_assets/img/company/outline/map_icon.png",
          new google.maps.Size(120, 54) /*アイコンサイズ設定*/,
          new google.maps.Point(0, 0) /*アイコン位置設定*/
        );
        var markerOptions = {
          position: latlng,
          map: map,
          icon: icon,
          title: "株式会社アルペン",
        };
        var marker = new google.maps.Marker(
          markerOptions
        ); /*アイコン設定ここまで▲*/
      }
    }
  },
};

//$(window).on("load",function () {
$(window).on("load modalOpen", function () {
  if ($(".c-modal__map")[0]) map.init();
});
